import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import LogisticsReportsMobile from "../mobile/logistics/LogisticsReportsMobile";
import ShipmentReports from "./reports/ShipmentReports";

export default function ResponsiveShipmentReports(props) {
  return useIsMobile() ? <LogisticsReportsMobile {...props} /> : <ShipmentReports {...props} />;
}
